import axios from 'axios'
import store from '../store'
import router from '../router'
import { getToken } from '@/utils/storage'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 5000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['x-auth-token'] = token // 让每个请求携带自定义token 请根据实际情况自行修改
    } else {
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    /**
     * status为非1是抛错 可结合自己业务进行修改
     */
    const res = response.data
    if (res.status <= -100) {
      store.dispatch('FedLogOut').then(() => {
        // location.reload() // 为了重新实例化vue-router对象 避免bug
        router.push({path: '/login/index'})
      })
      return Promise.reject(new Error(res.msg))
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error) // for debug
    // this.$message.error(error.message, 5)
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js